import React from "react";
import styled from "styled-components";
import { string } from "prop-types";

const StyledErrorMessage = styled.div`
  color: red;
  font-size: 0.5rem;
  padding: ${({ padding }) => padding};
`;

const OnboardingErrorMessage = ({ error, padding }) => (
  <StyledErrorMessage padding={padding}>{error}</StyledErrorMessage>
);

OnboardingErrorMessage.propTypes = {
  error: string.isRequired,
  padding: string
};

export default OnboardingErrorMessage;
